import { render, staticRenderFns } from "./LargeButton.vue?vue&type=template&id=41656d71&scoped=true&"
import script from "./LargeButton.vue?vue&type=script&lang=js&"
export * from "./LargeButton.vue?vue&type=script&lang=js&"
import style0 from "./LargeButton.vue?vue&type=style&index=0&id=41656d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41656d71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
